module.exports = __webpack_public_path__ + "img/team-3.07f7a974.jpg";